import React from "react";
import Starfield from "./components/Starfield";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";

const styles = {
  heading: {
    fontSize: "clamp(1.8rem, 4vw, 3.5rem)",  // Responsive scaling
    fontWeight: "700",
    textAlign: "center",
    margin: "2rem auto 1rem",
    maxWidth: "90%",
    lineHeight: 1.3,
    color: "rgba(255, 255, 255, 0.9)",
    textShadow: "0 0 12px rgba(255, 255, 255, 0.3)"
  },
  highlight: {
    color: "#00eaff"
  }
};



const projects = [
  {
    title: "Chord Finder",
    description: "Find chords in any song with one tap.",
    image: "/images/chord-finder-hero.png",
    link: "https://www.digitalladyland.com/chord-finder"
  },
  {
    title: "Guitar Tabs Agent",
    description: "Get accurate guitar tabs using AI + web crawling.",
    image: "/images/guitar-tabs-hero.png", // note the typo in "cuitar" if that's intentional
    link: "https://ai.digitalladyland.com/guitar-tabs"
  },
  {
    title: "YourPhotoAI",
    description: "Generate stunning AI photos in seconds.",
    image: "/images/your-photo-ai-hero.png",
    link: "https://yourphotoai.com"
  }
];

function App() {
  return (
    <div className="App">
      <Starfield />
      <Header />
      <main style={{ position: "relative", zIndex: 1 }}>
        <h1 style={styles.heading}>
          Where imagination meets <span style={styles.highlight}>intelligent design</span>
        </h1>
        {projects.map((p, i) => (
          <HeroSection key={p.title} {...p} reverse={i % 2 !== 0} />
        ))}
      </main>
      <Footer />
    </div>
  );
}

export default App;
